import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

import translationEN from '@src/i18n/translations/en.json';
import translationLT from '@src/i18n/translations/lt.json';
import translationRO from '@src/i18n/translations/ro.json';

const resources = {
  en: {
    translation: translationEN,
  },
  lt: {
    translation: translationLT,
  },
  ro: {
    translation: translationRO,
  },
};

const options = {
  order: ['querystring', 'htmlTag', 'navigator'],
  lookupQuerystring: 'lng',
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // detection: options,
    resources,
    fallbackLng: process.env.GATSBY_DEFAULT_LANGUAGE || 'en',
    supportedLngs: ['lt', 'en', 'ro'],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      useSuspense: true,
    },
  });
i18n.changeLanguage(process.env.GATSBY_DEFAULT_LANGUAGE || 'en');

export default i18n;
